import React from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import UserTable from '../components/studentslist/BaseUserTable';

const UserList = () => {
    const additionalColumns = [
        {
            dataField: 'group',
            text: 'Группа',
            sort: true,
            filter: textFilter({
                placeholder: 'Поиск по группе...'
            })
        }
    ];

    return (
        <div>
            <h2>Пользователи</h2>
            <UserTable kind="users" additionalColumns={additionalColumns} />
        </div>
    );
};

export default UserList;